import i18n from 'i18next';
import httpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(httpApi)
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
});

export default i18n;
